const translations: Record<string, string> = {
  "ak_dsp3_xml_generated_mwh_split_across_assets": "XML generated: {{mwh}} MWh, split across {{n}} assets.",
  "ak_dsp3_version_for_deleted": "Version {{rev}} for {{d}} deleted.",
  "ak_dsp3_delivery_day_kyiv_time": "delivery day {{d}} · Kyiv time",
  "ak_dsp3_version": "Version {{n}}",
  "ak_dsp3_progress_version": "Progress · Version {{n}}",
  "ak_dsp3_send_to_mms_submits_the_generated_xml": "\"Send to MMS\" submits the generated XML schedule to Ukrenergo via the API (mTLS SOAP via jmms). The submission status is shown in the event feed above (queued → submitted / error). Ukrenergo validation is asynchronous; an authorization error means the technical user has not yet been provisioned on their side.",
  "ak_dsp3_manual_entry_version": "Manual entry - Version {{n}}",
  "ak_dsp3_versions": "versions: {{n}}",
  "ak_dsp3_version_2": "version {{n}}",
  "ak_dsp3_your_solar_plant_kwh": "your solar plant {{n}} kWh",
  "ak_dsp3_the_schedule_is_submitted_for_group_de": "The schedule is submitted for group {{x}} - deletion will remove the version for: {{a}}",
  "ak_dsp3_select_an_entry_its_hourly_values_will": "Select an entry - its hourly values will be loaded into \"Hourly data\" together with the actuals for that day, if it has already passed.",
  "ak_dsp3_version_history_for": "Version history for {{d}}",
  "ak_dsp3_error": "Error",
  "ak_dsp3_the_schedule_has_been_queued_for_submi": "The schedule has been queued for submission to MMS. The status will update within ~2 min.",
  "ak_dsp3_journal_entry_updated": "Journal entry updated.",
  "ak_dsp3_generated": "Generated",
  "ak_dsp3_submitted_to_mms": "Submitted to MMS",
  "ak_dsp3_received_by_mms": "Received by MMS",
  "ak_dsp3_processed_by_mms": "Processed by MMS",
  "ak_dsp3_status": "Status",
  "ak_dsp3_mms_interaction_log": "MMS interaction log",
  "ak_dsp3_loading": "Loading…",
  "ak_dsp3_no_journal_data_for_this_station": "No journal data for this station.",
  "ak_dsp3_schedule_versions": "Schedule versions",
  "ak_dsp3_mwh": "MWh",
  "ak_dsp3_ukrenergo_response": "Ukrenergo response",
  "ak_dsp3_show_xml_response": "show XML response",
  "ak_dsp3_generate_xml_build_the_schedule_from_t": "Generate XML: build the schedule from the forecast including manual adjustments",
  "ak_dsp3_available_for_the_active_version_only": "Available for the active version only",
  "ak_dsp3_download_xml": "Download XML",
  "ak_dsp3_send_to_mms_queue_the_schedule_and_sub": "Send to MMS: queue the schedule and submit it via the API (Ukrenergo)",
  "ak_dsp3_generate_the_xml_first": "Generate the XML first",
  "ak_dsp3_hide_xml_archive": "Hide XML archive",
  "ak_dsp3_xml_archive": "XML archive",
  "ak_dsp3_collapse_manual_entry": "Collapse manual entry",
  "ak_dsp3_enter_manually_record_mms_times_and_st": "Enter manually: record MMS times and status",
  "ak_dsp3_time_sent_to_mms": "Time sent to MMS",
  "ak_dsp3_time_received_by_mms": "Time received by MMS",
  "ak_dsp3_status_message_time": "Status message time",
  "ak_dsp3_mms_status": "MMS status",
  "ak_dsp3_not_set": "- not set -",
  "ak_dsp3_saving": "Saving…",
  "ak_dsp3_save_entry": "Save entry",
  "ak_dsp3_an_empty_field_means_no_change_time_is": "An empty field means no change. Time is entered in Kyiv time.",
  "ak_dsp3_saved_schedules": "Saved schedules",
  "ak_dsp3_delete_the_saved_schedule_version": "Delete the saved schedule version",
  "ak_dsp3_delete_for_the_whole_group": "Delete for the whole group?",
  "ak_dsp3_confirm": "Confirm?",
  "ak_dsp3_the_schedule_was_already_submitted_the": "The schedule was already submitted - the entry stays in the journal",
  "ak_dsp3_version_3": "Version",
  "ak_dsp3_state": "State",
  "ak_dsp3_submitted": "Submitted",
  "ak_dsp3_received": "Received",
  "ak_dsp3_processed": "Processed",
  "ak_dsp3_by": "By",
};

export default translations;
